export enum AnalyzeDataTabQueryParam {
    ColumnStats = 'stats',
    Categorization = 'categorization',
    AICategorization = 'ai_categorization',
    DataValidation = 'validation',
    Error = 'error',
    DataEnrichment = 'enrichment',
    Workspace = 'workspace'
}

export enum DataValidationConditionQueryParam {
    Required = 'req',
    Recommended = 'rec',
    Optional = 'opt'
}

export enum DataValidationIssueQueryParam {
    Invalid = 'inv',
    Misformatted = 'misf',
    Missing = 'mis',
    TooLong = 'long',
    TooShort = 'short',
    AiRejection = 'ai'
}
